module.exports = "pegasus_template/assets/x_gray.png";